import {PlayerReduxState} from "../types";
import {ChallengeMode} from "../../../schema";

export default function getMaxLevel(state: PlayerReduxState): number {
  switch (state.challenge.mode) {
    case ChallengeMode.COMPETENCE_TEST:
    case ChallengeMode.CHOICE_BASED_STUDY:
    case ChallengeMode.CHOICES_WITH_CUSTOM_SCORES:
    case ChallengeMode.CUSTOM_PARAMETERS_TEST:
    case ChallengeMode.RPG_MODE:
      return 1;
    default:
      console.warn("getMaxLevel: unsupported challenge mode " + state.challenge.mode)
      return 1;
  }
}
